import { format_routes } from '@/utils/tools';
import { lazy } from 'react';

const Notice = lazy(() => import('@/pages/notice/index/index'));
const NoticeCompanyRelevance = lazy(() => import('@/pages/notice/company/relevance'));


export const noticeRouter = [
  {
    path: '/notice',
    element: <Notice />,
    key: 'notice',
    // label: 'Company Management', //公司管理,
    children: [
      {
        path: '/notice/company_relevance',
        element: <NoticeCompanyRelevance />,
        key: 'companyInfo',
        parentKey: 'companyManagement',
        label: 'Company Basic Information', //公司基本信息
      },
      // {
      //   path: '/company/detail',
      //   element: <CompanyDetail />,
      //   key: 'companyDetail',
      //   parentKey: 'companyManagement',
      //   label: 'Company Detail Information', //公司详情信息
      // },
      // {
      //   path: '/company/address',
      //   element: <CompanyAddress />,
      //   key: 'companyAddress',
      //   parentKey: 'companyManagement',
      //   label: 'Company Address Management', // '公司地址管理',
      // },
      // {
      //   path: '/company/delivery',
      //   element: <CompanyDelivery />,
      //   key: 'companyDelivery',
      //   parentKey: 'companyManagement',
      //   label: 'Company Delivery Management', //'公司配送管理',
      // },
      // {
      //   path: '/company/aptitude',
      //   element: <CompanyAptitude />,
      //   key: 'companyAptitude',
      //   parentKey: 'companyManagement',
      //   label: 'Company License Management', // '公司资质管理',
      // },
    ],
  }
];

export const format_notice_router_routes = format_routes(noticeRouter);